<body>
    <div>
        <table class="table-selects">
            <thead>
                <tr>
                    <th class="flex">
                        <div class="divHeader central">
                            <h1>TIME TABLE LCB</h1>
                            <div class="legenda">
                                <div class="item-legenda">
                                    <span class="cor" style="background-color: #b90505"></span>
                                    <span class="descricao">Atrasado</span>
                                </div>
                                <!-- </div>
                            <div class="legenda"> -->
                                <div class="item-legenda">
                                    <span class="cor" style="background-color:#2c669c"></span>
                                    <span class="descricao">Em Tempo</span>
                                </div>
                                <!-- </div>
                            <div class="legenda"> -->
                                <div class="item-legenda">
                                    <span class="cor" style="background-color:#c5b34a"></span>
                                    <span class="descricao">Chegou Nao Entrou</span>
                                </div>
                                <!-- </div>
                            <div class="legenda"> -->
                                <div class="item-legenda">
                                    <span class="cor" style="background-color:#3d8148"></span>
                                    <span class="descricao">Chegou e Entrou</span>
                                </div>
                                <div class="item-legenda">
                                    <span class="cor" style="  background-color: #c5b34a; border: red solid 8px"></span>
                                    <span class="descricao">Chegou Atrasado e Nao Entrou</span>
                                </div>
                                <div class="item-legenda">
                                    <span class="cor" style="background-color: #4f9d5c;  border: red solid 8px"></span>
                                    <span class="descricao">Finalizado Atrasado</span>
                                </div>
                                <div class="item-legenda">
                                    <span class="cor"
                                        style="   background-color: #4b4b4a;  border: rgb(59, 163, 45) solid 8px"></span>
                                    <span class="descricao">Finalizado</span>
                                </div>
                                <div class="item-legenda">
                                    <span class="cor"
                                        style=" background-color: #4b4b4a; border: rgb(23, 27, 240) solid 8px"></span>
                                    <span class="descricao">Finalizada Manual</span>
                                </div>

                            </div>
                        </div>
                        <div class="divHeader">
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'RECCONT')"><i-feather
                                    name="printer"></i-feather>REC Container</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'EXP')"><i-feather
                                    name="printer"></i-feather>EXP</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'INT')"><i-feather
                                    name="printer"></i-feather>INT</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'EMB')"><i-feather
                                    name="printer"></i-feather>EMB</button>
                            <button class="btn-frete icone-setting" mat-button
                                (click)="exportToExcel(timeTableGeral,'RECSIDER')"><i-feather
                                    name="printer"></i-feather>REC SIDER</button>
                        </div>
                    </th>
                </tr>
            </thead>
        </table>
        <table>
            <thead>
                <tr>
                    <th class="flexEdit">
                        <!-- <div class="data">
                            <span>{{ dataExibir | date : 'dd/MM/yyyy' }}</span>
                        </div> -->
                        <div *ngIf="this.usuarioLogado" class="divHeader">
                            <input class="largo" type="date" name="dataExibirPre" [(ngModel)]="dataExibirPre">
                            <button class="atualizar" (click)="atualizaData()">Atualizar</button>
                            <!-- <button *ngIf="this.usuarioLogado.role == '9' && this.usuarioLogado.id == 'ssbuif' " class="limpar" (click)="limparTabela()">Limpar Tabela</button>
                            <button *ngIf="this.usuarioLogado.role == '9' && this.usuarioLogado.id == 'ssbuif' " class="limpar" (click)="salvarTodosDeUmaVez(itemTimeTable)">Atualizar Tabela</button> -->
                            <div class="data">
                                <span>{{ dataExibir | date : 'dd/MM/yyyy' }}</span>
                            </div>
                        </div>
                        <div class="flex1">
                            <!-- <h3 class="textoSelecione">
                                Selecione as áreas que deseja visualizar
                            </h3> -->
                            <input type="checkbox" [(ngModel)]="RECCONT"> REC CONTAINER
                            <input type="checkbox" [(ngModel)]="EXP"> EXP
                            <input type="checkbox" [(ngModel)]="INT"> INT
                            <input type="checkbox" [(ngModel)]="EMB"> EMB
                            <input type="checkbox" [(ngModel)]="RECSIDER"> REC SIDER
                        </div>
                        <div>
                            <button
                                *ngIf="this.usuarioLogado && (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9')"
                                class="btn-editSlot icone-setting" mat-button (click)="editSlot()"><i-feather
                                    name="edit"></i-feather>Editar Slots</button>
                        </div>
                        <div>
                            <button
                                *ngIf="this.usuarioLogado && (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9')"
                                class="btn-editSlot icone-setting" mat-button (click)="editVolumes()"><i-feather
                                    name="edit"></i-feather>Editar Volumes</button>
                        </div>
                    </th>
                </tr>
            </thead>
        </table>
        <table *ngIf="this.usuarioLogado && this.usuarioLogado.role == '9' && this.usuarioLogado.id == 'ssbuif' ">
            <thead>
                <tr>
                    <th class="flexEdit">
                        <div class="flex1">
                            <button *ngIf="this.usuarioLogado.role == '9' && this.usuarioLogado.id == 'ssbuif' "
                                class="limpar" (click)="limparTabela()">Limpar Tabela</button>
                            <button *ngIf="this.usuarioLogado.role == '9' && this.usuarioLogado.id == 'ssbuif' "
                                class="limpar" (click)="salvarTodosDeUmaVez(itemTimeTable)">Atualizar Tabela</button>
                            <input type="checkbox" [(ngModel)]="redistribuirAutomatica"> Redistribuir Automatico
                        </div>
                    </th>
                </tr>
            </thead>
        </table>

        <!-- <body>
            <div class="container">
                <table class="table-selects">
                    <thead>
                        <tr>
                            <th class="flex naoAlocado">
                                <h1>VEICULOS NÃO ALOCADOS</h1>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="table-container scrollable-container">
                <table>
                    <thead class="sticky-header">
                        <tr>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Veículo</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Volumes</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Area</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Janelas</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Transportadora</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Fornecedor</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Chegada</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Entrada</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="2">
                                <span class="semFundo">Saida</span>
                            </th>
                            <th class="titulo-coluna excesso" colspan="1">
                                <span class="semFundo">Editar</span>
                            </th>
                        </tr>
                    </thead>          
                    <tbody *ngFor="let area of ['RECCONT', 'RECSIDER']">
                        <tr *ngFor="let item of overflowTable[area]">
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso">{{ item.Plate }}
                                    <span *ngIf="item.idContainer"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">/ Container:
                                        </abbr>
                                        {{ item.ID }}<br> </span> </label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso">{{item.Volumes}}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso">{{item.area}}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso">{{item.horaJanelaTimeTable}}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso">{{item.Transportadora}}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso">{{item.Fornecedores}}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso"> {{ item.ChegadaLCB ? (item?.ChegadaLCB |
                                    date : 'dd/MM/yyyy HH:mm') : (item?.chegada | date :
                                    'dd/MM/yyyy HH:mm' : '+00:00') }}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso"> {{ item.EntradaLCB ? (item.EntradaLCB | date
                                    : 'dd/MM/yyyy HH:mm') : (item?.entrada | date :
                                    'dd/MM/yyyy HH:mm') }}</label>
                            </td>
                            <td [ngClass]="item?.statusChegadaLCB" colspan="2">
                                <label class="labelExcesso"> {{ item.SaidaLCB ? (item.SaidaLCB | date :
                                    'dd/MM/yyyy HH:mm') : (item?.saida | date :
                                    'dd/MM/yyyy HH:mm') }}</label>
                            </td>
                            <td class="labelExcesso action">
                                <button (click)="editDialog(item)">Editar</button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colspan="19" style="border-top: 20px solid #cf7106; padding: 0;"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </body> -->

        <body>
            <div class="testeFixo" *ngIf="telaCarregada">
                <table class="geralTable">
                    <thead>
                        <tr *ngIf="slotLimitsCriacaoHTML != {}">
                            <th class="titulo-coluna" colspan="1">
                                <span class="semFundo">HORÁRIO</span>
                            </th>
                            <th *ngIf="RECCONT" class="titulo-coluna" [attr.colspan]="slotLimitsCriacaoHTML['RECCONT']">
                                <span class="semFundo">CONTAINER</span>
                            </th>
                            <th *ngIf="RECSIDER" class="titulo-coluna"
                                [attr.colspan]="slotLimitsCriacaoHTML['RECSIDER']">
                                <span class="semFundo">SIDER</span>
                            </th>
                            <th *ngIf="EXP" class="titulo-coluna" [attr.colspan]="slotLimitsCriacaoHTML['EXP']">
                                <span class="semFundo">EXP</span>
                            </th>
                            <th *ngIf="INT" class="titulo-coluna" [attr.colspan]="slotLimitsCriacaoHTML['INT']">
                                <span class="semFundo">INT</span>
                            </th>
                            <th *ngIf="EMB" class="titulo-coluna"
                                [attr.colspan]="slotLimitsCriacaoHTML['EMB'] + slotLimitsCriacaoHTML['EMBMR']">
                                <span class="semFundo">EMB</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let _ of [].constructor(24); let i = index;">
                            <td class="centralizado" [ngClass]="classHora ? classHora[i] : ''"><br>
                                <div>
                                    <abbr style="color: #cccbc9; font-size: 4.5vh; font-weight: bold;">{{i}}:00 </abbr>
                                </div><br>
                                <div> <span
                                        [ngClass]="horasEstouradas['RECCONT'] && horasEstouradas['RECCONT'][i] ? 'estourouLimite' : ''"
                                        *ngIf="RECCONT"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">CONT:
                                        </abbr> {{ this.limiteVolumes['RECCONT'][i] }} - {{ valorItemVolume[i][0] }} =
                                        {{
                                        this.limiteVolumes['RECCONT'][i] - valorItemVolume[i][0] }} </span></div>
                                <div><span
                                        [ngClass]="horasEstouradas['RECSIDER'] && horasEstouradas['RECSIDER'][i] ? 'estourouLimite' : ''"
                                        *ngIf="RECSIDER"> <abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">SIDER:
                                        </abbr>
                                        {{ this.limiteVolumes['RECSIDER'][i] }} - {{ valorItemVolume[i][1] }} = {{
                                        this.limiteVolumes['RECSIDER'][i] - valorItemVolume[i][1] }} </span></div>
                                <div><span
                                        [ngClass]="horasEstouradas['RECCONT'] && horasEstouradas['EXP'][i] ? 'estourouLimite' : ''"
                                        *ngIf="EXP"> <abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">EXP:
                                        </abbr> {{ valorItemVolume[i][2].toFixed(2) }} </span></div>
                                <div><span
                                        [ngClass]="horasEstouradas['RECCONT'] && horasEstouradas['INT'][i] ? 'estourouLimite' : ''"
                                        *ngIf="INT"> <abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">INT:
                                        </abbr> {{ valorItemVolume[i][3].toFixed(2) }} </span></div>
                                <div><span
                                        [ngClass]="horasEstouradas['RECCONT'] && horasEstouradas['EMB'][i] ? 'estourouLimite' : ''"
                                        *ngIf="EMB"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">EMB:
                                        </abbr> {{ valorItemVolume[i][4].toFixed(2) }} </span></div>
                                <div><span
                                        [ngClass]="horasEstouradas['RECCONT'] && horasEstouradas['EMBMR'][i] ? 'estourouLimite' : ''"
                                        *ngIf="EMBMR"><abbr
                                            style="color: #000000; font-size: 1.8vh; font-weight: bold;">EMBMR:
                                        </abbr> {{ valorItemVolume[i][4].toFixed(2) }} </span></div>
                            </td>
                            <ng-container *ngIf="RECCONT">
                                <td *ngFor="let slot of getArray(slotLimitsCriacaoHTML['RECCONT']); let j = index"
                                    [ngClass]="timeTableGeral[i]['RECCONT'][j]?.statusChegadaLCB"
                                    (click)="timeTableGeral[i]['RECCONT'][j] ? editDialog(timeTableGeral[i]['RECCONT'][j]) : editDialog2('RECCONT')">
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.ID }} </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.created"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.created | date : 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.lastUpdate"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last
                                                Update.:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.lastUpdate | date : 'dd/MM/yyyy HH:mm'
                                            }} by
                                            {{
                                            timeTableGeral[i]['RECCONT'][j]?.UpdateByUser }}
                                        </span>
                                    </div>
                                    <div *ngIf="timeTableGeral[i]['RECCONT'][j]?.idContainer" class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.ID }}<br> </span>
                                    </div>
                                    <div *ngIf="timeTableGeral[i]['RECCONT'][j]?.CTNRAlugado" class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.CTNRAlugado"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container
                                                Alugado:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.CTNRAlugado }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.Transportadora"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.Transportadora }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.Plate "><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Placa:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.Plate }}</span>
                                    </div>
                                    <div class="infos">
                                        <span class="fornecedores"
                                            *ngIf="timeTableGeral[i]['RECCONT'][j]?.Fornecedores"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.Fornecedores }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.Volumes"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.Volumes }}</span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECCONT'][j]?.SequenciaLCB"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j]?.SequenciaLCB }}</span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['RECCONT'][j] && (timeTableGeral[i]['RECCONT'][j].ChegadaLCB || timeTableGeral[i]['RECCONT'][j].chegada)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j].ChegadaLCB ?
                                            (timeTableGeral[i]['RECCONT'][j].ChegadaLCB |
                                            date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['RECCONT'][j]?.chegada | date : 'dd/MM/yyyy HH:mm' :
                                            '+00:00') }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['RECCONT'][j] && (timeTableGeral[i]['RECCONT'][j].entrada || timeTableGeral[i]['RECCONT'][j].EntradaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j].EntradaLCB ?
                                            (timeTableGeral[i]['RECCONT'][j].EntradaLCB | date
                                            : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][j]?.entrada | date :
                                            'dd/MM/yyyy HH:mm') }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['RECCONT'][j] && (timeTableGeral[i]['RECCONT'][j].saida || timeTableGeral[i]['RECCONT'][j].SaidaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:
                                            </abbr>
                                            {{ timeTableGeral[i]['RECCONT'][j].SaidaLCB ?
                                            (timeTableGeral[i]['RECCONT'][j].SaidaLCB | date :
                                            'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['RECCONT'][j]?.saida | date :
                                            'dd/MM/yyyy HH:mm') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>



                            <!-- /****************************************************************************************************************************************************/ -->

                            <ng-container *ngIf="RECSIDER">
                                <td *ngFor="let slot of getArray(slotLimitsCriacaoHTML['RECSIDER']); let j = index"
                                    [ngClass]="timeTableGeral[i]['RECSIDER'][j]?.statusChegadaLCB"
                                    (click)="timeTableGeral[i]['RECSIDER'][j] ? editDialog(timeTableGeral[i]['RECSIDER'][j]) : editDialog2('RECSIDER')">

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.ID">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">ID:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.ID }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.created">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Created:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.created | date : 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.lastUpdate">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last
                                                Update:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.lastUpdate | date : 'dd/MM/yyyy HH:mm'
                                            }}
                                            by {{ timeTableGeral[i]['RECSIDER'][j]?.UpdateByUser }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.Transportadora">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.Transportadora }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.Plate">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.Plate }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.Volumes">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.Volumes }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.SequenciaLCB">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.SequenciaLCB }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.Fornecedores">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.Fornecedores }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['RECSIDER'][j]?.ChegadaLCB || timeTableGeral[i]['RECSIDER'][j]?.chegada">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.ChegadaLCB ?
                                            (timeTableGeral[i]['RECSIDER'][j]?.ChegadaLCB | date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['RECSIDER'][j]?.chegada | date : 'dd/MM/yyyy HH:mm' :
                                            '+00:00')
                                            }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['RECSIDER'][j]?.EntradaLCB || timeTableGeral[i]['RECSIDER'][j]?.entrada">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.EntradaLCB ?
                                            (timeTableGeral[i]['RECSIDER'][j]?.EntradaLCB | date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['RECSIDER'][j]?.entrada | date : 'dd/MM/yyyy HH:mm') }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.AtendRecebLCB">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Atend.
                                                Receb
                                                LCB:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.AtendRecebLCB | date : 'dd/MM/yyyy
                                            HH:mm'
                                            }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['RECSIDER'][j]?.FinalRecebLCB">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Final
                                                Receb
                                                LCB:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.FinalRecebLCB | date : 'dd/MM/yyyy
                                            HH:mm'
                                            }}
                                        </span>
                                    </div>

                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['RECSIDER'][j]?.SaidaLCB || timeTableGeral[i]['RECSIDER'][j]?.saida">
                                            <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:</abbr>
                                            {{ timeTableGeral[i]['RECSIDER'][j]?.SaidaLCB ?
                                            (timeTableGeral[i]['RECSIDER'][j]?.SaidaLCB | date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['RECSIDER'][j]?.saida | date : 'dd/MM/yyyy HH:mm') }}
                                        </span>
                                    </div>

                                </td>
                            </ng-container>

                            <!-- /****************************************************************************************************************************************************/ -->
                            <ng-container *ngIf="EXP">
                                <td *ngFor="let slot of getArray(slotLimitsCriacaoHTML['EXP']); let j = index"
                                    [ngClass]="timeTableGeral[i]['EXP'][j]?.statusChegadaLCB"
                                    (click)="timeTableGeral[i]['EXP'][j] ? editDialog(timeTableGeral[i]['EXP'][j]) : editDialog2('EXP')">
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.ID }} </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.created"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.created | date : 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.lastUpdate"> <abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Last
                                                Update.:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by
                                            {{
                                            timeTableGeral[i]['EXP'][j]?.UpdateByUser }}
                                        </span>
                                    </div>
                                    <div *ngIf="timeTableGeral[i]['EXP'][j]?.idContainer" class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.ID }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.Transportadora"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.Transportadora }}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.Plate "><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.Plate }}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span class="fornecedores"
                                            *ngIf="timeTableGeral[i]['EXP'][j]?.Fornecedores"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.Fornecedores }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.Volumes"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.Volumes }}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EXP'][j]?.SequenciaLCB"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.SequenciaLCB }}</span>
                                    </div>

                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EXP'][j] && (timeTableGeral[i]['EXP'][j].ChegadaLCB|| timeTableGeral[i]['EXP'][j].chegada)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.ChegadaLCB?
                                            (timeTableGeral[i]['EXP'][j]?.ChegadaLCB
                                            |
                                            date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['EXP'][j]?.chegada | date :
                                            'dd/MM/yyyy HH:mm' : '+00:00')}}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EXP'][j] && (timeTableGeral[i]['EXP'][j].entrada || timeTableGeral[i]['EXP'][j].EntradaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.EntradaLCB ?
                                            (timeTableGeral[i]['EXP'][j]?.EntradaLCB |
                                            date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][j]?.entrada | date :
                                            'dd/MM/yyyy HH:mm')}}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EXP'][j] && (timeTableGeral[i]['EXP'][j].saida || timeTableGeral[i]['EXP'][j].SaidaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:
                                            </abbr>
                                            {{ timeTableGeral[i]['EXP'][j]?.SaidaLCB ?
                                            (timeTableGeral[i]['EXP'][j]?.SaidaLCB |
                                            date :
                                            'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EXP'][j]?.saida | date :
                                            'dd/MM/yyyy HH:mm')}}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>


                            <!-- /*****************************************************************************************************/// -->
                            <ng-container *ngIf="INT">
                                <td *ngFor="let slot of getArray(slotLimitsCriacaoHTML['INT']); let j = index"
                                    [ngClass]="timeTableGeral[i]['INT'][j]?.statusChegadaLCB"
                                    (click)="timeTableGeral[i]['INT'][j] ? editDialog(timeTableGeral[i]['INT'][j]) : editDialog2('INT')">
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['INT'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                            </abbr>
                                            {{ timeTableGeral[i]['INT'][j]?.ID }} </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['INT'][j]?.created"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                            </abbr>
                                            {{ timeTableGeral[i]['INT'][j]?.created | date : 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['INT'][j]?.Transportadora"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.:
                                            </abbr>
                                            {{ timeTableGeral[i]['INT'][j]?.Transportadora }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['INT'][j]?.Plate "><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa:
                                            </abbr>
                                            {{ timeTableGeral[i]['INT'][j]?.Plate }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['INT'][j]?.Volumes"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:
                                            </abbr>
                                            {{ timeTableGeral[i]['INT'][j]?.Volumes }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['INT'][j]?.SequenciaLCB"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro:
                                            </abbr>
                                            {{ timeTableGeral[i]['INT'][j]?.SequenciaLCB }}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- /********************************************************************************************************************************/ -->
                            <ng-container *ngIf="EMB">
                                <td *ngFor="let slot of getArray(slotLimitsCriacaoHTML['EMB']); let j = index"
                                    [ngClass]="timeTableGeral[i]['EMB'][j]?.statusChegadaLCB"
                                    (click)="timeTableGeral[i]['EMB'][j] ? editDialog(timeTableGeral[i]['EMB'][j]) : editDialog2('EMB')">
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.ID }} </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.created"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.created | date : 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.lastUpdate"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last
                                                Update.:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }} by
                                            {{
                                            timeTableGeral[i]['EMB'][j]?.UpdateByUser }} </span>
                                    </div>
                                    <div *ngIf="timeTableGeral[i]['EMB'][j]?.idContainer" class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.ID }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.Transportadora"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.Transportadora }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.Plate "><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.Plate }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.Volumes"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.Volumes }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMB'][j]?.SequenciaLCB"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.SequenciaLCB }}</span>
                                    </div>
                                    <div class="infos">
                                        <span class="fornecedores"
                                            *ngIf="timeTableGeral[i]['EMB'][j]?.Fornecedores"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.Fornecedores }}<br> </span>
                                    </div>

                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EMB'][j] && (timeTableGeral[i]['EMB'][j].ChegadaLCB|| timeTableGeral[i]['EMB'][j].chegada)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.ChegadaLCB ?
                                            (timeTableGeral[i]['EMB'][j]?.ChegadaLCB |
                                            date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['EMB'][j]?.chegada | date :
                                            'dd/MM/yyyy HH:mm' : '+00:00')}}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EMB'][j] && (timeTableGeral[i]['EMB'][j].entrada || timeTableGeral[i]['EMB'][j].EntradaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.EntradaLCB ?
                                            (timeTableGeral[i]['EMB'][j]?.EntradaLCB |
                                            date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EMB'][j]?.entrada | date :
                                            'dd/MM/yyyy HH:mm')}}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EMB'][j] && (timeTableGeral[i]['EMB'][j].saida || timeTableGeral[i]['EMB'][j].SaidaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMB'][j]?.SaidaLCB ?
                                            (timeTableGeral[i]['EMB'][j]?.SaidaLCB |
                                            date :
                                            'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EMB'][j]?.saida | date :
                                            'dd/MM/yyyy HH:mm')}}
                                        </span>
                                    </div>
                                </td>
                                <!-- </ng-container> -->
                                <!-- /********************************************************************************************************************************/ -->
                                <!-- 
                        <ng-container *ngIf="EMBMR"> -->
                                <td *ngFor="let slot of getArray(slotLimitsCriacaoHTML['EMBMR']); let j = index"
                                    [ngClass]="timeTableGeral[i]['EMBMR'][j]?.statusChegadaLCB"
                                    (click)="timeTableGeral[i]['EMBMR'][j] ? editDialog(timeTableGeral[i]['EMBMR'][j]) : editDialog2('EMBMR')">
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> ID:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.ID }} </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.created"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Created:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.created | date : 'dd/MM/yyyy HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.lastUpdate"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;"> Last
                                                Update.:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.lastUpdate | date : 'dd/MM/yyyy HH:mm' }}
                                            by
                                            {{
                                            timeTableGeral[i]['EMBMR'][j]?.UpdateByUser }} </span>
                                    </div>
                                    <div *ngIf="timeTableGeral[i]['EMBMR'][j]?.idContainer" class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.ID"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Container:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.ID }}<br> </span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.Transportadora"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Transp.:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.Transportadora }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.Plate "><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Placa:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.Plate }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.Volumes"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Volumes:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.Volumes }} <br></span>
                                    </div>
                                    <div class="infos">
                                        <span *ngIf="timeTableGeral[i]['EMBMR'][j]?.SequenciaLCB"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Registro:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.SequenciaLCB }}</span>
                                    </div>
                                    <div class="infos">
                                        <span class="fornecedores"
                                            *ngIf="timeTableGeral[i]['EMBMR'][j]?.Fornecedores"><abbr
                                                style="color: #000000; font-size: 1.8vh; font-weight: bold;">Fornecedores:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.Fornecedores }}<br> </span>
                                    </div>

                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EMBMR'][j] && (timeTableGeral[i]['EMBMR'][j].ChegadaLCB|| timeTableGeral[i]['EMBMR'][j].chegada)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Chegada:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.ChegadaLCB ?
                                            (timeTableGeral[i]['EMBMR'][j]?.ChegadaLCB |
                                            date : 'dd/MM/yyyy HH:mm') :
                                            (timeTableGeral[i]['EMBMR'][j]?.chegada | date :
                                            'dd/MM/yyyy HH:mm' : '+00:00')}}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EMBMR'][j] && (timeTableGeral[i]['EMBMR'][j].entrada || timeTableGeral[i]['EMBMR'][j].EntradaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Entrada:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.EntradaLCB ?
                                            (timeTableGeral[i]['EMBMR'][j]?.EntradaLCB |
                                            date : 'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EMBMR'][j]?.entrada | date
                                            :
                                            'dd/MM/yyyy HH:mm')}}
                                            <br></span>
                                    </div>
                                    <div class="infos">
                                        <span
                                            *ngIf="timeTableGeral[i]['EMBMR'][j] && (timeTableGeral[i]['EMBMR'][j].saida || timeTableGeral[i]['EMBMR'][j].SaidaLCB)">
                                            <abbr style="color: #000000; font-size: 1.8vh; font-weight: bold;">Saida:
                                            </abbr>
                                            {{ timeTableGeral[i]['EMBMR'][j]?.SaidaLCB ?
                                            (timeTableGeral[i]['EMBMR'][j]?.SaidaLCB |
                                            date :
                                            'dd/MM/yyyy HH:mm') : (timeTableGeral[i]['EMBMR'][0]?.saida | date :
                                            'dd/MM/yyyy HH:mm')}}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </body>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000">
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="transportadora" [(ngModel)]="item.transportadora" class="modal-input1">
                        <!-- <input type="text" name="ID" [(ngModel)]="item.ID" class="modal-input1"> -->
                    </td>
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Volumes</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="Volumes" [(ngModel)]="item.Volumes" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td *ngIf="edit2">
                        <label class="modal-label">Destino 1</label>
                    </td>
                    <td class="align-left input-maior" *ngIf="edit2">
                        <input type="text" name="forn1" [(ngModel)]="item.forn1" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Janela Original</label>
                    </td>
                    <td class="align-left input-maior" *ngIf="!edit2">
                        <input readonly type="date" name="dataJanelaOriginal" [(ngModel)]="item.dataJanelaOriginal"
                            class="modal-input1">
                        <input readonly type="time" name="horaJanelaOriginal" [(ngModel)]="item.horaJanelaOriginal"
                            class="modal-input1">
                    </td>
                    <td class="align-left input-maior" *ngIf="edit2">
                        <input [readonly]="!edit2" type="date" name="dataJanelaTimeTable"
                            [(ngModel)]="item.dataJanelaTimeTable" class="modal-input1">
                        <input [readonly]="!edit2" type="time" name="horaJanelaTimeTable"
                            [(ngModel)]="item.horaJanelaTimeTable" class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="!edit2 && this.usuarioLogado" class="flexEdit">
                    <td>
                        <label class="modal-label">Janela</label>
                    </td>
                    <td class="align-left input-maior">
                        <input
                            [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9' && this.usuarioLogado.role != '7'"
                            type="date" name="dataAlteradaLCB" [(ngModel)]="item.dataAlteradaLCB" class="modal-input1">
                        <input
                            [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9' && this.usuarioLogado.role != '7'"
                            type="time" name="horaAlteradaLCB" [(ngModel)]="item.horaAlteradaLCB" class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="!isCarrierEnabled" class="flexEdit">
                    <td>
                        <label class="modal-label">Area</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="area" [(ngModel)]="item.area" class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="this.usuarioLogado" class="flexEdit">
                    <td class="input-maior">
                        <label class="modal-label">Motivo da alteração*</label>
                        <select
                            [disabled]="this.usuarioLogado.role != '2' && this.usuarioLogado.role != '9'  && this.usuarioLogado.role != '7'"
                            id="motAlteracao" name="motAlteracao" [(ngModel)]="item.motAlteracao" class="modal-select"
                            (blur)="onFieldTouched()">
                            <option *ngFor="let opcao of opcoesMotivoFiltradas" [value]="opcao.valor">
                                {{ opcao.descricao }}
                            </option>
                            <!-- <option value=0>-</option>
                            <option value=1>Atraso no transporte/Transportadora</option>
                            <option value=2>Atraso no fornecedor</option>
                            <option value=3>Atraso no recebimento/SCANIA</option>
                            <option value=4>Atraso no recebimento/LCB</option>
                            <option value=5>Excesso de veículos no mesmo horário</option>
                            <option value=6>Chegada antecipada</option>                     -->
                        </select>
                        <div
                            *ngIf="campoTocado && (item.motAlteracao == null || item.motAlteracao == undefined || item.motAlteracao == 0)">
                            <small class="text-danger">Required</small>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="item.idContainer" class="flexEdit">
                    <td>
                        <label class="modal-label">Nº Container</label>
                    </td>
                    <td class="align-left input-maior">
                        <input disabled type="text" name="idContainer" [(ngModel)]="item.idContainer"
                            class="modal-input1">
                    </td>
                </tr>
                <tr *ngIf="item.idContainer" class="flexEdit">
                    <td>
                        <label class="modal-label">Nº Container Alugado</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="CTNRAlugado" [(ngModel)]="item.CTNRAlugado" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn2">
                    <td>
                        <label class="modal-label">Destino 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn2" [(ngModel)]="item.forn2" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 2</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="jan2" [(ngModel)]="item.jan2" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn3">
                    <td>
                        <label class="modal-label">Destino 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn3" [(ngModel)]="item.forn3" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janela 3</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="jan3" [(ngModel)]="item.jan3" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit" *ngIf="item.forn4">
                    <!-- <td>
                        <label class="modal-label">Destino 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="forn4" [(ngModel)]="item.forn4" class="modal-input1">
                    </td> -->
                    <td>
                        <label class="modal-label">Janela 4</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="text" name="jan4" [(ngModel)]="item.jan4" class="modal-input1">
                    </td>
                </tr>
                <tr class="flexEdit">
                    <td>
                        <label class="modal-label">Fornecedores</label>
                    </td>
                    <td class="input-maior">
                        <input type="text" name="Fornecedores" [(ngModel)]="item['Fornecedores']"
                            class="modal-input1 letraMenor">
                    </td>
                </tr>
            </table>
            <div class="modal-div botoes">
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="reservaEmbalagem(item)">Coletar
                    Embalagem</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="reutilizarEXP(item)">Reutilizar
                    Container</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="deleteItem(item)">Cancelar
                    Reserva</button>
                <button *ngIf="!edit2" [disabled]="isCarrierEnabled" class="modal-button" type="button"
                    (click)="FinalizarViagem(item)">Finalizar Viagem</button>
                <button *ngIf="!edit2" class="modal-button" type="button" (click)="salvar()">Save</button>
                <button *ngIf="edit2" class="modal-button" type="button" (click)="salvarNovo()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
                <!-- <input  type="checkbox" name="coletaEmbalagem" [(ngModel)]="item.coletaEmbalagem" class="modal-input1"><abbr  style="color: #dbdbdb; font-size: 1.8vh; font-weight: bold;">Coletar Embalagem</abbr> -->
                <button *ngIf="!edit2" [disabled]="!ADMEnabled" class="modal-button" type="button"
                    (click)="deleteItem(item)">Delete</button>
            </div>
        </form>
    </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="dialogOpenSlots" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Detalhes</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="tableSlots">
                <caption>Quantidade Slots</caption>
                <tr class="camposSlots">
                    <td class="camposSlots">
                        <label class="modal-label">Sider</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotRecsider" [(ngModel)]="slots.slotRecsider"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Cont</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotReccontainer" [(ngModel)]="slots.slotReccontainer"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Int</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotInt" [(ngModel)]="slots.slotInt" class="modal-input1">
                    </td>
                </tr>
                <tr class="camposSlots">
                    <td>
                        <label class="modal-label">Emb Int</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotEmb" [(ngModel)]="slots.slotEmb" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Emb MR</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotEmbMR" [(ngModel)]="slots.slotEmbMR" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Exp</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotExp" [(ngModel)]="slots.slotExp" class="modal-input1">
                    </td>
                </tr>
            </table>
            <table class="tableSlots camposSlots">
                <caption>Quantidade Slots horário reduzido</caption>
                <tr class="camposSlots">
                    <td>
                        <label class="modal-label">Sider</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotRecsiderReduzido" [(ngModel)]="slots.slotRecsiderReduzido"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Cont</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotReccontainerReduzido"
                            [(ngModel)]="slots.slotReccontainerReduzido" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Int</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotIntReduzido" [(ngModel)]="slots.slotIntReduzido"
                            class="modal-input1">
                    </td>
                </tr>
                <tr class="camposSlots">
                    <td>
                        <label class="modal-label">Emb Int</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotEmbReduzido" [(ngModel)]="slots.slotEmbReduzido"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Emb MR</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotEmbMRReduzido" [(ngModel)]="slots.slotEmbMRReduzido"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Exp</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.slotExpReduzido" [(ngModel)]="slots.slotExpReduzido"
                            class="modal-input1">
                    </td>
                </tr>
            </table>
            <table class="tableSlots camposSlots">
                <caption>Horários Reduzidos</caption>
                <tr class="camposSlots">
                    <td>
                        <label class="modal-label">Troca de turno</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.horarioTrocaTurno" [(ngModel)]="slots.horarioTrocaTurno"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Almoço</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.horarioAlmoco" [(ngModel)]="slots.horarioAlmoco"
                            class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Janta</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type='text' name="slots.horarioJanta" [(ngModel)]="slots.horarioJanta"
                            class="modal-input1">
                    </td>
                </tr>
            </table>
            <div class="modal-div botoes">
                <button class="modal-button" type="button" (click)="salvarSlots()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="dialogOpenVolumes" [clrModalSize]="'sm'" class="dialog-container">
    <h3 class="modal-title">Configuração</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="tableSlots">
                <caption>Volumes por Hora</caption>
                <tr class="camposSlots">
                    <td class="camposSlots">
                        <label class="modal-label">Sider</label>
                    </td>
                    <td>
                        <div class="scroll-horas">
                            <div class="align-left volumesHora" *ngFor="let hora of horas; let h = index">
                                <label class="modal-label">Hora {{ hora }}:00</label>
                                <!-- <input type='text' disabled name="hora" [value]="hora" class="inputVolumes"> -->
                                <!-- <label class="modal-label">Volume</label> -->
                                <input type='number' [name]="'volumesHoraRecsider_' + h"
                                    [(ngModel)]="volumesHoraRecsider[h]" class="inputVolumes">
                            </div>
                        </div>
                    </td>
                    <td>
                        <label class="modal-label">Cont</label>
                    </td>
                    <td>
                        <div class="scroll-horas">
                            <div class="align-left volumesHora" *ngFor="let hora of horas; let h = index">
                                <!-- <td class="align-left volumesHora" *ngFor="let hora of horas; let h = index"> -->
                                <label class="modal-label">Hora {{ hora }}:00</label>
                                <!-- <input type='number' disabled name="hora" [value]="hora" class="inputVolumes">
                                <label class="modal-label">Volume</label> -->
                                <input type='number' [name]="'volumesHoraRecCont_' + h"
                                    [(ngModel)]="volumesHoraRecCont[h]" class="inputVolumes">
                            </div>
                        </div>
                    </td>
                    <td>
                        <label class="modal-label">Int</label>
                    </td>
                    <!-- <td class="align-left volumesHora" *ngFor="let hora of horas; let h = index"> -->
                    <td>
                        <div class="scroll-horas">
                            <div class="align-left volumesHora" *ngFor="let hora of horas; let h = index">
                                <label class="modal-label">Hora {{ hora }}:00</label>
                                <!-- <input type='number' disabled name="hora" [value]="hora" class="inputVolumes">
                                <label class="modal-label">Volume</label> -->
                                <input type='number' [name]="'volumesHoraInt_' + h" [(ngModel)]="volumesHoraInt[h]"
                                    class="inputVolumes">
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="camposSlots">
                    <td>
                        <label class="modal-label">Emb</label>
                    </td>
                    <!-- <td class="align-left volumesHora" *ngFor="let hora of horas; let h = index"> -->
                    <td>
                        <div class="scroll-horas">
                            <div class="align-left volumesHora" *ngFor="let hora of horas; let h = index">
                                <label class="modal-label">Hora {{ hora }}:00</label>
                                <!-- <input type='number' disabled name="hora" [value]="hora" class="inputVolumes">
                                <label class="modal-label">Volume</label> -->
                                <input type='number' [name]="'volumesHoraEmb_' + h" [(ngModel)]="volumesHoraEmb[h]"
                                    class="inputVolumes">
                            </div>
                        </div>
                    </td>
                    <td>
                        <label class="modal-label">Emb MR</label>
                    </td>
                    <!-- <td class="align-left volumesHora" *ngFor="let hora of horas; let h = index"> -->
                    <td>
                        <div class="scroll-horas">
                            <div class="align-left volumesHora" *ngFor="let hora of horas; let h = index">
                                <label class="modal-label">Hora {{ hora }}:00</label>
                                <!-- <input type='number' disabled name="hora" [value]="hora" class="inputVolumes">
                                <label class="modal-label">Volume</label> -->
                                <input type='number' [name]="'volumesHoraEmbMR_' + h" [(ngModel)]="volumesHoraEmbMR[h]"
                                    class="inputVolumes">
                            </div>
                        </div>
                    </td>
                    <td>
                        <label class="modal-label">Exp</label>
                    </td>
                    <!-- <td class="align-left volumesHora" *ngFor="let hora of horas; let h = index"> -->
                    <td>
                        <div class="scroll-horas">
                            <div class="align-left volumesHora" *ngFor="let hora of horas; let h = index">
                                <label class="modal-label">Hora {{ hora }}:00</label>
                                <!-- <input type='number' disabled name="hora" [value]="hora" class="inputVolumes">
                                <label class="modal-label">Volume</label> -->
                                <input type='number' [name]="'volumesHoraExp_' + h" [(ngModel)]="volumesHoraExp[h]"
                                    class="inputVolumes">
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
            <div class="modal-div botoes">
                <button class="modal-button" type="button" (click)="criarVolumesSlots()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>


<div *ngIf="!totalMR || isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>